import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPuzzle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPuzzle"><Path d="M9.5 4.5H3.5V19.5H20.5V14.5H20C18.6193 14.5 17.5 13.3807 17.5 12C17.5 10.6193 18.6193 9.5 20 9.5H20.5V4.5H14.5V4C14.5 2.61929 13.3807 1.5 12 1.5C10.6193 1.5 9.5 2.61929 9.5 4V4.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconPuzzle;
